/**
* @File * @Author huyuying
* @Author huyuying liubin
* @FilePath src/main/router/routers/lx.js
*/
import lx from '../modules/lx.js'
export default [

    // ---链信----
    {path: '/Lx/H5/repayment.htm',name:'repayment', component:lx.repayment,meta:{single:true,title: '云信还款提醒'}},//还款提醒
    {path: '/Lx/H5/financing.htm',name:'financing', component:lx.financing,meta:{single:true,title: '云信融资详情'}},//融资详情
    {path: '/Lx/H5/examine.htm',name:'examine', component:lx.examine,meta:{single:true,title: '企业认证审批拒绝详情'}},//审批结果
    {path: '/Lx/H5/corporateFriends.htm',name:'corporateFriends', component:lx.corporateFriends,meta:{single:true,title: '好友邀请'}},//企业好友(好友邀请)
    {path: '/Lx/H5/imprintDocument.htm',name:'imprintDocument', component:lx.imprintDocument,meta:{single:true,title: '链信印迹文档'}},//印迹文档
    {path: '/Lx/H5/introduceLx.htm',name:'introduceLx', component:lx.introduceLx,meta:{single:true,title: '链信介绍'}},//链信介绍
    {path: '/Lx/H5/introduceYx.htm',name:'introduceYx', component:lx.introduceYx,meta:{single:true,title: '链信介绍'}},//链信-云信融资介绍
    {path: '/Lx/H5/appIntroduce.htm',name:'appIntroduce', component:lx.appIntroduce,meta:{single:true,title: '应用介绍'}},//应用介绍
    {path: '/Lx/H5/invalid.htm',name:'invalid', component:lx.invalid},//失效
    {path: '/Lx/H5/lxDown.htm',name:'lxDown', component:lx.lxDown},//链信下载
    {path: '/Lx/H5/imageShow.htm',name:'imageShow', component:lx.imageShow},//分享图片
    {path: '/Lx/H5/taskDetail.htm',name:'imageShow', component:lx.taskDetail},
    {path: '/Lx/H5/pdfView.htm',name:'imageShow', component:lx.pdfView},

    //链信盲盒--跳转页
    {path: '/Lx/blindBox/jumpLxApp',name:'jumpLxApp', component:lx.jumpLxApp,meta:{single:true,title: '中企云链'}},
    //链信盲盒--首页
    {path: '/Lx/blindBox/index',name:'index', component:lx.index,meta:{single:true,title: ''}},
    //链信盲盒--详情
    {path: '/Lx/blindBox/blindBoxDetails',name:'blindBoxDetails', component:lx.blindBoxDetails,meta:{single:true,title: '中企云链盲盒'}},
    //链信盲盒--我的盲盒
    {path: '/Lx/blindBox/myBlindBox',name:'myBlindBox', component:lx.myBlindBox,meta:{single:true,title: '我的盲盒'}},
    //链信盲盒--没抽中盲盒
    {path: '/Lx/blindBox/emptyBox',name:'emptyBox', component:lx.emptyBox,meta:{single:true,title: '中企云链盲盒'}},

    {path: '/Lx/H5/FactoringShare.htm',name:'FactoringShare', component:lx.FactoringShare},//跨行再保理分享

    //链信企业圈-H5页面分享
    {path: '/Lx/companyCircle/shareDetail',name:'shareDetail', component:lx.shareDetail,meta:{single:true}},
    //链信企业圈-文章详情页面
    {path: '/Lx/companyCircle/articleDetail',name:'articleDetail', component:lx.articleDetail,meta:{single:true}},

    // 链信H5-共创计划
    {path: '/Lx/H5/createPlan.htm',name:'createPlan', component:lx.createPlan},

    //协议签署
    {path: '/Lx/sign.htm',name:'sign', component:lx.sign},
    {path: '/Lx/filingSign.htm',name:'filingSign', component:lx.filingSign},

    //链信H5-云信使用指南
    {path: '/yxUsageGuide.htm',name:'yxUsageGuide', component:lx.yxUsageGuide,meta:{single:true,title: '云信使用指南'}},//链信-云信使用指南

    /* LXN-929 */
    {path: '/lx/editorPreview/:id', name: 'editorPreview', component: lx.editorPreview, meta:{ single: true }},//链信-图文预览
    
    /* end */
]